import Splide from '@splidejs/splide';

const EL = '.js-gallery';

document.querySelectorAll('.js-gallery').forEach((carousel) => {
  const slider = new Splide(carousel, {
    // type: 'loop',
    perPage: 3,
    perMove: 1,
    gap: 26,
    arrows: true,
    pagination: false,
    breakpoints: {
      1024: {

      },
      767: {
        perPage: 1,
      },
    },
  });

  slider.mount();
});
